export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.22-1624.43",
  commitId: "2f8136cd132c71e2856e9c91c9784c71a488c649",
  commitTime: "2026-05-22T16:24:43.000Z",
});
